var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVerifiedGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "cx4wwbblxa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#61A51D",
    d: "M5.354 1.79c.87-.504 1.792-.639 2.764-.406C8.603.823 9.223.436 9.978.227c1.017-.283 1.988-.155 2.914.384.363.211.674.452.933.723.416-.03.843.014 1.28.132 1.014.273 1.79.874 2.327 1.804.065.113.125.226.18.34.423.08.85.246 1.278.495.925.54 1.521 1.324 1.787 2.354.208.807.173 1.581-.107 2.324.12.156.234.328.34.512.537.93.67 1.902.4 2.918-.132.49-.336.922-.615 1.298l-.016-.067c.266 1.03.135 2.008-.395 2.933-.529.925-1.302 1.53-2.32 1.812l-.05.013-.07.234c-.296.893-.86 1.58-1.69 2.06-.857.494-1.763.633-2.717.415-.414.355-.904.612-1.469.769-1.017.282-1.989.154-2.914-.385-.245-.143-.467-.3-.665-.47-.637.181-1.299.179-1.986-.006-1.015-.273-1.791-.875-2.328-1.804-.176-.305-.311-.61-.404-.914-.204-.08-.41-.18-.615-.3-.926-.539-1.521-1.323-1.787-2.354-.146-.564-.172-1.112-.08-1.645-.216-.233-.415-.504-.593-.812-.536-.93-.669-1.902-.398-2.918.189-.709.532-1.298 1.03-1.766l.038.156C1 7.432 1.132 6.454 1.662 5.53c.474-.83 1.145-1.4 2.012-1.714.3-.877.86-1.552 1.68-2.026z",
    transform: "translate(-641 -95) translate(641 95)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#cx4wwbblxa)",
    transform: "translate(-641 -95) translate(641 95)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M7.004 12.557L2.94 8.787c-.114-.107-.17-.243-.17-.41 0-.166.056-.303.17-.409l.9-.817c.114-.122.256-.182.426-.182.17 0 .32.06.45.182l2.726 2.544 5.842-5.452c.13-.121.28-.182.45-.182.17 0 .312.06.426.182l.9.818c.114.106.17.242.17.409 0 .166-.056.302-.17.408l-7.18 6.68c-.113.12-.26.18-.438.18s-.324-.06-.438-.18z",
    transform: "translate(1.4 3.8)"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedGreen);
export default __webpack_public_path__ + "static/media/verified-green.221c6983a9ccce3c267aae616dc9a938.svg";
export { ForwardRef as ReactComponent };